export default __webpack_public_path__ + "static/media/simply-smarter-eng-1.7046dda2.jpg";